import { DateTime as DT } from 'luxon';
import { UserNameItem } from 'modules/user';
import SolarIcon from 'components/icons/SolarIcon';
import type { HistoryDeadlineRow } from './model';

interface HistoryDeadlineTableRowProps {
    row: HistoryDeadlineRow;
}

const formatDay = (millis: number) =>
    millis ? DT.fromMillis(millis).toFormat('dd.MM.yyyy') : '—';

const HistoryDeadlineTableRow = ({ row }: HistoryDeadlineTableRowProps) => {
    const date = DT.fromMillis(row?.dt || 0).toFormat('dd.MM.yyyy');
    const time = DT.fromMillis(row?.dt || 0).toFormat('HH:mm');

    return (
        <tr>
            <td className="username">
                <UserNameItem
                    smallMode
                    user={{
                        userName: row.userName,
                        userEmail: row.userEmail,
                        userPicture: row.userPicture || undefined,
                    }}
                />
            </td>
            <td className="date">
                <span className="d-block">{date}</span>
                <span className="d-block text-muted fs-12">{time}</span>
            </td>
            <td className="change">
                <div className="history-price-change">
                    <span className="history-price-change__old">
                        {formatDay(Number(row?.oldDeadline || 0))}
                    </span>
                    <SolarIcon name="arrow-right" className="history-price-change__arrow" aria-hidden="true" />
                    <span className="history-price-change__new">
                        {formatDay(Number(row?.newDeadline || 0))}
                    </span>
                </div>
            </td>
            <td className="comment">
                {row.comment ? (
                    <span className="history-price-comment">{row.comment}</span>
                ) : (
                    <span className="text-muted">—</span>
                )}
            </td>
        </tr>
    );
};

export default HistoryDeadlineTableRow;
